import styled from "styled-components";

export const ConsultationInfoCardContainer = styled.div`
  display: flex;
  flex-direction: column;

  .title-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    img {
      display: block;
      width: 24px;
      height: 24px;
      object-fit: contain;
    }

    h5 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.32;
      color: rgba(0, 0, 0, 0.88);
    }
  }

  .consultation-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px;

    p {
      margin: 0;
      font-size: 13px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.88);
    }

    > div {
      display: flex;
      justify-content: space-between;
      gap: 16px;

      p:last-child {
        font-size: 15px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.74);
        text-align: right;
      }
    }
  }

  .amount-container {
    display: none;
  }

  @media (min-width: 768px) {
    .amount-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    .amount-container p {
      margin: 0;
      font-size: 13px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.88);
    }

    .amount-container .amount {
      font-size: 24px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.88);
    }
  }
`;
